export default function Services() {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Infrastructure Development',
      items: [
        'Turnkey project planning & execution',
        'Civil engineering & construction',
        'Road & bridge works',
        'Urban development'
      ]
    },
    {
      icon: 'ri-hammer-line',
      title: 'Construction Services',
      items: [
        'Residential & commercial construction',
        'Project management & consulting',
        'Architecture and structural execution'
      ]
    },
    {
      icon: 'ri-earth-line',
      title: 'Mining & Minerals',
      items: [
        'Exploration & extraction planning',
        'Mining operations support',
        'Mineral processing'
      ]
    },
    {
      icon: 'ri-vip-diamond-line',
      title: 'Gems & Jewellery',
      items: [
        'Sourcing and trading',
        'Jewellery design and distribution',
        'Export services'
      ]
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Corporate Support',
      items: [
        'Investment advisory',
        'Strategic consulting',
        'Compliance and regulatory support'
      ]
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Services</h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Comprehensive solutions across multiple industries, delivered with excellence and precision
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 group hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <ul className="space-y-3">
                {service.items.map((item, idx) => (
                  <li key={idx} className="flex items-start text-gray-600 text-sm">
                    <i className="ri-check-line text-[#C9A961] text-lg mr-2 flex-shrink-0 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}